function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#icon-trash_svg__clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M30 60c16.568 0 30-13.43 30-30C60 13.433 46.567.002 30 .002c-16.569 0-30 13.431-30 30 0 16.568 13.431 30 30 30z",
  fill: "#ABCCF8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M58.09 19.443H42.675c-.981 0-1.868-.398-2.51-1.041a3.551 3.551 0 012.51-6.061h2.204a3.551 3.551 0 003.55-3.551c0-.733.222-1.414.603-1.98a30.047 30.047 0 019.058 12.633zM34.394 12.623a3.551 3.551 0 01-3.551 3.551h-20.75a3.54 3.54 0 01-2.51-1.04 3.545 3.545 0 01-1.04-2.51c0-.386-.061-.756-.177-1.104.395-.504.805-.995 1.231-1.473C12.924 4.072 20.606.24 29.186.011a3.548 3.548 0 01-3.174 1.96h-2.204a3.55 3.55 0 100 7.101h7.035c.98 0 1.868.397 2.51 1.04a3.54 3.54 0 011.04 2.511z",
  fill: "#7BA2D5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M60 30.1a29.925 29.925 0 01-2.811 12.598C52.406 52.918 42.029 60 30 60 17.97 60 7.595 52.919 2.812 42.698a29.907 29.907 0 01-1.99-5.694 29.979 29.979 0 01-.82-6.903H60z",
  fill: "#353E40"
}), /*#__PURE__*/React.createElement("path", {
  d: "M57.098 31.078H39.171V17.654H53.02l4.078 13.424z",
  fill: "#353E40"
}), /*#__PURE__*/React.createElement("path", {
  d: "M58.185 27.266l-3.824-9.44a2.468 2.468 0 00-2.288-1.541H37.108v26.413h20.08a30.013 30.013 0 001.196-2.96V28.28c0-.348-.068-.692-.199-1.014zm-5.397 1.033H41.79a1.881 1.881 0 01-1.881-1.88V21.06c0-1.09.883-1.973 1.973-1.973h8.636c.803 0 1.527.488 1.828 1.233l2.183 5.392a1.88 1.88 0 01-1.742 2.587zM37.107 13.466v29.232H2.812A29.894 29.894 0 010 30V12.447a2.4 2.4 0 012.4-2.4h31.835c1.586 0 2.872 1.53 2.872 3.419z",
  fill: "#80E0A7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M58.309 39.954c-.33.937-.704 1.852-1.12 2.744h-7.276c-6.59 0-.76-1.985-1.056-2.744h9.452z",
  fill: "#797B89"
}), /*#__PURE__*/React.createElement("path", {
  d: "M47.812 48.824a6.111 6.111 0 100-12.223 6.111 6.111 0 000 12.223z",
  fill: "#353E40"
}), /*#__PURE__*/React.createElement("path", {
  d: "M47.813 46.25a3.537 3.537 0 100-7.075 3.537 3.537 0 000 7.075z",
  fill: "#92A1A4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M48.612 44.898a2.986 2.986 0 01-1.264-5.69 3.538 3.538 0 103.97 3.97 2.985 2.985 0 01-2.706 1.72z",
  fill: "#F3F4F3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M55.605 37.936a2.198 2.198 0 100-4.396 2.198 2.198 0 000 4.396z",
  fill: "#CAFEE6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M55.573 32.673h-2.166v7.28h2.166v-7.28z",
  fill: "#23A56B"
}), /*#__PURE__*/React.createElement("path", {
  d: "M52.575 23.9c.205.654-.552 1.185-1.097.77l-2.02-1.539-2.118-1.613c-.536-.408-.248-1.263.426-1.263h3.151c.308 0 .58.2.672.493l.986 3.151zM37.108 37.004v5.694H2.812a29.91 29.91 0 01-1.99-5.694h36.286z",
  fill: "#546164"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.668 35.013h-9.606c-.62 0-1.16.42-1.315 1.02l-.498 1.936a1.358 1.358 0 001.315 1.697h10.603c.887 0 1.536-.838 1.315-1.697l-.498-1.937a1.358 1.358 0 00-1.316-1.02z",
  fill: "#546164"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.865 48.824a6.111 6.111 0 100-12.223 6.111 6.111 0 000 12.223z",
  fill: "#353E40"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.865 46.25a3.537 3.537 0 100-7.075 3.537 3.537 0 000 7.075z",
  fill: "#92A1A4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.666 44.898a2.986 2.986 0 01-1.265-5.69 3.538 3.538 0 103.97 3.97 2.985 2.985 0 01-2.705 1.72z",
  fill: "#F3F4F3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M41.103 32.081h2.752c.383 0 .694-.31.694-.693v-.049a.694.694 0 00-.694-.694h-2.752a.694.694 0 00-.694.694v.049c0 .383.311.693.694.693z",
  fill: "#353E40"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.758 12.537l-1.396 1.168-2.074 5.21-4.042-1.609 1.387-3.484a2.134 2.134 0 012.014-1.344l4.11.059z",
  fill: "#F3F4F3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19 19.162l1.794-1.106-4.949-5.575 3.913.056c.76.01 1.477.363 1.95.957l1.99 2.492 1.631-1.224-1.275 4.904L19 19.162zM8.002 26.227l1.602.864h5.607v4.35h-3.75a2.134 2.134 0 01-1.994-1.373l-1.465-3.841z",
  fill: "#F3F4F3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.437 24.481l-1.69-1.257-3.35 6.659-1.395-3.656a2.542 2.542 0 01.168-2.166l1.58-2.77-1.741-1.063 5.027-.63 1.401 4.883zM26.312 29.8l-.097-1.817-2.922-4.786 3.713-2.267 1.954 3.2a2.134 2.134 0 01-.134 2.418l-2.514 3.253zM21.468 25.217l-.192 2.099 7.43-.611-2.394 3.096a2.543 2.543 0 01-1.937.985l-3.187.095v2.04l-3.157-3.964 3.437-3.74z",
  fill: "#F3F4F3"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "icon-trash_svg__clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h60v60H0z"
})));

function SvgIconTrash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 60 60",
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgIconTrash;